import React from 'react'
import './InformationBox.css'

const InformationBox = ({ number, title, texts, background }) => {

    return (
        <div
            className="information-box-container"
            style={{
                backgroundImage: `url(${background})`,
                backgroundSize: 'cover',
                backgroundPosition: 'top center',
            }}>
            <p className='box-number'>{number + 1}</p>
            <p className='box-title'>{title}</p>
            <ul className="box-text-list">
                {texts.map((item, index) => (
                    <li key={index} className="box-list-item">
                        {item}
                    </li>
                ))}
            </ul>
        </div>
    )
}

export default InformationBox
